import { isAffiliateOperatorId } from '@entities/operator';
import { type IHotelOfferTariff } from '@ve/components/hotel/hotelOffersTariffsPopup/common/types';
import { type IReturnProductHotelOffer } from '@ve/pages/hotel/types';

export default (hotelOffers: IReturnProductHotelOffer[]): IHotelOfferTariff[] =>
  hotelOffers
    .filter((hotelOffer) => !hotelOffer.operator || !isAffiliateOperatorId(hotelOffer.operator.id))
    .map((hotelOffer) => ({
      tourId: hotelOffer.id,
      price: hotelOffer.price,
      roomName: hotelOffer.room.name,
      cancellationPolicy: hotelOffer.cancellationPolicy,
    }));
